export default {
  FETCH_DASHBOARD_REQUEST: 'FETCH_DASHBOARD_REQUEST',
  FETCH_DASHBOARD_SUCCESS: 'FETCH_DASHBOARD_SUCCESS',
  FETCH_DASHBOARD_FAILURE: 'FETCH_DASHBOARD_FAILURE',

  SET_DASHBOARD_LAYOUTS: 'SET_DASHBOARD_LAYOUTS',
  SET_DASHBOARD_EDIT_MODE: 'SET_DASHBOARD_EDIT_MODE',
  SET_DASHBOARD_COPY: 'SET_DASHBOARD_COPY',
  SET_DASHBOARD_CURRENT: 'SET_DASHBOARD_CURRENT',
  SET_DASHBOARD_WIDGETS_LIST: 'SET_DASHBOARD_WIDGETS_LIST',

  SAVE_DASHBOARD_REQUEST: 'SAVE_DASHBOARD_REQUEST',
  SAVE_DASHBOARD_SUCCESS: 'SAVE_DASHBOARD_SUCCESS',
  SAVE_DASHBOARD_FAILURE: 'SAVE_DASHBOARD_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/action-types.js